








































import Vue from "vue";
import { Component, Prop } from "vue-property-decorator";
import { db, firestore } from "@/scripts/firebase";
import { JinroPlayerDocument, JinroRoomDocument } from "@/services/datatypes";
import { DialogProgrammatic as Dialog } from "buefy";
import { collectionName } from "../../services/collection-name";
import { ToastProgrammatic as Toast } from "buefy";
import { TOAST_DURATION_MILLISECONDS } from "@/services/constants";
import PlayerStatus from "@/components/JinroRoom/PlayerStatus.vue";

@Component({
  components: {
    PlayerStatus,
  },
})
export default class PlayerListViewWithStatus extends Vue {
  @Prop() readonly isActionsNeeded!: boolean;
  detacher?: firebase.Unsubscribe;
  players: Array<JinroPlayerDocument> = [];

  get jinroRoom(): JinroRoomDocument | null {
    if (!this.$store.state.jinroRoom) {
      return null;
    }
    return this.$store.state.jinroRoom;
  }

  handleDelete(playerId: string) {
    const player = this.players.find((player) => {
      return player.id === playerId;
    }) as JinroPlayerDocument;
    Dialog.confirm({
      message: `「${player.playerName}」を削除しますか。削除されたプレイヤーはゲームに参加できなくなります。`,
      type: "is-danger",
      cancelText: "キャンセル",
      confirmText: "削除する",
      onConfirm: async () => this.deletePlayer(playerId, player.playerName),
    });
  }

  async deletePlayer(playerId: string, playerName: string) {
    if (!this.jinroRoom) {
      return;
    }
    await db
      .collection(collectionName.jinrorooms)
      .doc(this.jinroRoom.id)
      .collection(collectionName.jinroplayers)
      .doc(playerId)
      .set(
        {
          isDeleted: true,
          timeUpdated: firestore.FieldValue.serverTimestamp(),
        },
        { merge: true }
      );

    Toast.open({
      duration: TOAST_DURATION_MILLISECONDS,
      type: "is-info",
      queue: false,
      message: `「${playerName}」が削除されました。`,
    });
  }

  isMe(uid: string): boolean {
    return uid === this.uid;
  }

  get isOwner() {
    if (!this.jinroRoom) {
      return false;
    }
    return (
      this.$store.state.firebaseUser &&
      this.jinroRoom.owner === this.$store.state.firebaseUser.uid
    );
  }

  isLoadingNeeded(playerUid: string, playerName: string): boolean {
    if (this.uid !== playerUid) {
      return false;
    }
    const displayName = this.$store.state.user.displayName;
    return playerName !== displayName;
  }

  isLinkNeeded(player: JinroPlayerDocument): boolean {
    const playerUid = player.uid;
    // `playerUid === null` means guest player created by owner
    if (this.isOwner && playerUid === null) {
      return true;
    }
    if (this.uid === playerUid) {
      return true;
    }
    return false;
  }

  get uid(): string {
    if (this.$store.state.firebaseUser) {
      return this.$store.state.firebaseUser.uid;
    }

    return "";
  }

  created() {
    if (!this.jinroRoom) {
      return;
    }
    this.detacher = db
      .collection(collectionName.jinrorooms)
      .doc(this.jinroRoom.id)
      .collection(collectionName.jinroplayers)
      .orderBy("timeCreated", "desc")
      .onSnapshot((snapshot) => {
        const allPlayers = snapshot.docs.map((doc) => {
          return Object.assign(doc.data(), {
            id: doc.id,
          }) as JinroPlayerDocument;
        });
        this.players = allPlayers.filter((player) => {
          return !!player.isDeleted === false;
        });
        this.$store.commit("setJinroRoomPlayers", this.players);
        this.$emit("player-number", this.players.length);
      });
  }
  destroyed() {
    this.detacher && this.detacher();
  }
}
